// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.haveValueTextValue[data-v-7c97ea42]{\r\n  background-color: #1da1f2;\r\n  color:white;\n}\r\n\r\n", ""]);
// Exports
module.exports = exports;
